import initialState from '../initialState';
import {
  UPDATE_NOTIFICATION_SUCCESS,
  SET_NOTIFICATIONS,
  RESTORE_SEARCH_NOTIFICATIONS,
  DELETE_SEARCH_NOTIFICATION_SUCCESS,
  DELETE_SEARCH_NOTIFICATION_ERROR,
  DISABLE_NOTIFICATION_SUCCESS,
  SET_NOTIFICATION_WEEKLY_FREQUENCY_SUCCESS,
} from './actionTypes';
import { replaceSearchNotification, deleteSearchNotification } from './utils';

function updateChanged(prevNotifications, currentNotification) {
  const foundNotification = prevNotifications.find(
    prevNotification => currentNotification.id === prevNotification.id
  );
  if (!foundNotification) {
    return {
      ...currentNotification,
      changed: false,
    };
  }
  return {
    ...currentNotification,
    changed: foundNotification.active !== currentNotification.active,
  };
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_NOTIFICATIONS:
      return payload.map(notification => updateChanged(state, notification));
    case UPDATE_NOTIFICATION_SUCCESS: {
      const updateNotification = updateChanged(state, payload);
      return replaceSearchNotification(state, updateNotification);
    }
    case RESTORE_SEARCH_NOTIFICATIONS:
      return payload.map(notification => ({ ...notification, changed: false }));
    case DELETE_SEARCH_NOTIFICATION_SUCCESS:
      return deleteSearchNotification(state, payload);
    case DELETE_SEARCH_NOTIFICATION_ERROR:
      return [...payload];
    case DISABLE_NOTIFICATION_SUCCESS:
      return replaceSearchNotification(state, payload);
    case SET_NOTIFICATION_WEEKLY_FREQUENCY_SUCCESS:
      return replaceSearchNotification(state, payload);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/SearchNotifications/reducer.js